var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{orange: _vm.theme == 'orange', blue: _vm.theme == 'blue', shadow: _vm.shadow, twoCols: _vm.twoCols}},[_vm._t("default"),_c('div',{staticClass:"content-container"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }